if (!customElements.get('pdp-collection-carousel')) {
  customElements.define(
    'pdp-collection-carousel',
    class PdpCollectionCarousel extends window.BAO.CustomElement {
      connectedCallback() {
        if (this.hasBeenInitialised) {
          super.connectedCallback()
          return
        }

        super.connectedCallback()
        this.setupCarousel()
      }

      setupCarousel() {
        const carousel = this.querySelector('s-carousel')
        const swiper = carousel?.carousel
        if (!swiper || swiper.destroyed) return
        swiper.update()
      }
    },
  )
}

const syncHeadingOverflow = (copy) => {
  const overflowing = copy.scrollWidth > copy.clientWidth + 1
  const atEnd = copy.scrollLeft + copy.clientWidth >= copy.scrollWidth - 1
  copy.classList.toggle('is-overflowing', overflowing)
  copy.classList.toggle('is-end', !overflowing || atEnd)
}

const bindHeadingOverflow = (root) => {
  root.querySelectorAll('.sec-PdpCollectionCarousel_HeadingCopy').forEach((copy) => {
    const update = () => syncHeadingOverflow(copy)
    if (copy.dataset.overflowBound !== 'true') {
      copy.dataset.overflowBound = 'true'
      copy.addEventListener('scroll', update, { passive: true })
      new ResizeObserver(update).observe(copy)
    }
    update()
  })
}

const syncTabSelection = (root, id) => {
  root.querySelectorAll('[data-pdp-collection-tab]').forEach((tab) => {
    tab.setAttribute('aria-selected', String(tab.dataset.pdpCollectionTab === id))
  })
}

const adoptRecommendations = (root) => {
  const incoming = root.querySelector('product-recommendations pdp-collection-carousel')
  if (!incoming || incoming.dataset.adopted) return
  if (!incoming.querySelector('.sec-PdpCollectionCarousel_Slide')) return

  incoming.dataset.adopted = 'true'

  const otherActive = [...root.querySelectorAll('pdp-collection-carousel.is-active')].find(
    (carousel) => carousel !== incoming,
  )
  if (otherActive) {
    incoming.hidden = true
    incoming.classList.remove('is-active')
  }

  const sourceTabs = incoming.querySelector('.sec-PdpCollectionCarousel_HeadingCopy')
  if (sourceTabs) {
    root.querySelectorAll('.sec-PdpCollectionCarousel_HeadingCopy').forEach((list) => {
      if (list === sourceTabs) return
      list.innerHTML = sourceTabs.innerHTML
    })
    bindHeadingOverflow(root)
  }

  const activeId = root.querySelector('pdp-collection-carousel.is-active')?.dataset.tabId
  if (activeId) syncTabSelection(root, activeId)
}

const bindCollectionCarouselTabs = (root) => {
  if (!root || root.dataset.tabsBound) return
  root.dataset.tabsBound = 'true'

  root.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-pdp-collection-tab]')
    if (!tab || !root.contains(tab)) return

    const id = tab.dataset.pdpCollectionTab
    const carousels = [...root.querySelectorAll('pdp-collection-carousel')]
    if (!carousels.some((carousel) => carousel.dataset.tabId === id)) return

    const scrollLeft = tab.closest('.sec-PdpCollectionCarousel_HeadingCopy')?.scrollLeft || 0

    carousels.forEach((carousel) => {
      const on = carousel.dataset.tabId === id
      carousel.hidden = !on
      carousel.classList.toggle('is-active', on)
      if (on) window.requestAnimationFrame(() => carousel.setupCarousel?.())
    })
    syncTabSelection(root, id)
    window.requestAnimationFrame(() => {
      root.querySelectorAll('.sec-PdpCollectionCarousel_HeadingCopy').forEach((copy) => {
        copy.scrollLeft = scrollLeft
      })
      bindHeadingOverflow(root)
    })
  })

  root.querySelectorAll('product-recommendations').forEach((recommendations) => {
    new MutationObserver(() => {
      adoptRecommendations(root)
    }).observe(recommendations, { childList: true, subtree: true })
  })
}

document.querySelectorAll('.prd-PdpCollectionCarouselSection').forEach((root) => {
  bindCollectionCarouselTabs(root)
  bindHeadingOverflow(root)
})

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector?.('.prd-PdpCollectionCarouselSection')
  if (!root) return
  bindCollectionCarouselTabs(root)
  bindHeadingOverflow(root)
})
